// Compare source claim IDs, not names, dates or roles: approval rows retain this link.
export function missingImportApprovals(record, approvalSourceIds) {
  if (record.status !== "imported") return [];
  const segments = (record.segments || []).filter(
    (segment) => segment.status !== "excluded",
  );
  const units = record.segments?.length ? segments : [record];
  return units.filter(
    (unit) => !unit.claim_id || !approvalSourceIds.has(Number(unit.claim_id)),
  );
}
